import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Reason } from "~@/pages/packages-settings/components/modals/UnsubscribeModal";

interface PackagesState {
  selectedReason: Reason | null;
}

const initialState: PackagesState = {
  selectedReason: null,
};

const packagesSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    setSelectedReason(state, action: PayloadAction<Reason | null>) {
      state.selectedReason = action.payload;
    },
    clearSelectedReason(state) {
      state.selectedReason = null;
    },
  },
});

export const { setSelectedReason, clearSelectedReason } = packagesSlice.actions;
export default packagesSlice.reducer;
